<div fxLayout="column" class="content-container" fxLayoutGap="10px">
  <mat-progress-bar class="default-progress-bar" mode="indeterminate" color="primary" *ngIf="isLoading"></mat-progress-bar>
  <app-grid-filter placeholder="Type '/' to bring up a list of available filters"
                   (selectedItemsChanged)="onSelectedItemsChanged($event)"
                   [selectedItemsChange]="selectedFilterChange"
                   [showFilterButton]="true" (onFilterButtonClicked)="openFilterDialog()"
                   [showDateRange]="true" [defaultDateRange]="dateRangeService.selectedDateRange?.action || 0"
                   [filterOptions]="filterOptions" (filterChangeEvent)="onFilterChanged($event)">
    <app-filter-row-additional-content>
    </app-filter-row-additional-content>
  </app-grid-filter>

  <div class="row total-rubic">
    <div class="col-sm-12 col-lg" *ngIf="cubicVisibility.answeredByUser">
      <app-dashboard-card title="Groups Answered Calls" [value]="grandTotals.answeredByUser"
                          [filterType]="1" (onClick)="onFilterTypeChange($event)"
                          [selectedFilterType]="dashboardService.selectedFilterType"
                          secondIconClass="fa-user no-rotate"
                          [backgroundColor]="colors.primaryBlue"></app-dashboard-card>
    </div>
    <div class="col-sm-12 col-lg" *ngIf="cubicVisibility.missedCalls">
      <app-dashboard-card title="Abandoned By Groups" [value]="grandTotals.missedCalls"
                          [filterType]="2" (onClick)="onFilterTypeChange($event)"
                          [selectedFilterType]="dashboardService.selectedFilterType"
                          secondIconClass="fa-plus" [backgroundColor]="colors.primaryRed"></app-dashboard-card>
    </div>
    <div class="col-sm-12 col-lg" *ngIf="cubicVisibility.avgTalkDuration">
      <app-dashboard-card title="Avg. Talk Duration" [value]="grandTotals.avgTalkDuration"
                          [filterType]="4" (onClick)="onFilterTypeChange($event)"
                          [selectedFilterType]="dashboardService.selectedFilterType"
                          [showAsDuration]="true" secondIconClass="fa-clock-o no-rotate"
                          [backgroundColor]="colors.teal"></app-dashboard-card>
    </div>
    <div class="col-sm-12 col-lg" *ngIf="cubicVisibility.avgWaitDuration">
      <app-dashboard-card title="Avg. Wait Duration" [value]="grandTotals.avgWaitDuration"
                          [filterType]="5" (onClick)="onFilterTypeChange($event)"
                          [selectedFilterType]="dashboardService.selectedFilterType"
                          [showAsDuration]="true" secondIconClass="fa-arrow-down"
                          [backgroundColor]="colors.primaryGreen"></app-dashboard-card>
    </div>
  </div>

  <mat-card appearance="outlined">
    <mat-card-content>
      <div class="column-chart">
        <app-chart-by-groups [data]="groupsSeriesTotals" [selectedFilterType]="dashboardService.selectedFilterType" [showExpand]="true"></app-chart-by-groups>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined">
    <mat-card-content>
      <div style="height: 375px">
        <app-chart-groups-by-time [data]="timeSeriesTotals" [chartType]="timeSeriesType" [showExpand]="true"
                           [startDate]="additionalFilter.startDate" [endDate]="additionalFilter.endDate"
                           [selectedFilterType]="dashboardService.selectedFilterType"></app-chart-groups-by-time>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined">
    <mat-card-title fxLayout="row" fxLayoutAlign="start center">
      <span fxFlex>Call Logs</span>
      <button mat-icon-button type="button" class="rect-btn button-32 export-logs" title="Export"
              (click)="onExportClick()">
        <mat-icon>download</mat-icon>
      </button>
    </mat-card-title>
    <mat-card-content>
      <div style="height: 800px;">
        <app-call-logs-grid #callLogsGrid [filterChangeEvent]="filterChangeEvent"></app-call-logs-grid>
      </div>
    </mat-card-content>
  </mat-card>
</div>
